import { OrmModel, StringField } from 'vuex-orm-decorators'
import BaseModel from '@/data/models/BaseModel'
import { modelNames } from '@/data/models/types'

@OrmModel(modelNames.STRIPO_TEMPLATE_TYPE)
export default class StripoTemplateType extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public name: string
}
